import Card from 'features/common/components/Card'
import points from 'assets/points.svg'
import useEmployees from '../../../../common/hooks/useEmployees'
import Spinner from 'features/common/components/Spinner'
import HeadRow from './components/HeadRow'
import BodyRow from './components/BodyRow'
import { useTranslation } from 'react-i18next'

const EmployeesTableCard = () => {
    const { data: employeeData, isLoading } = useEmployees()
    const { t } = useTranslation()
    if (isLoading) {
        return (
            <div className="flex items-center justify-center">
                <Spinner className='w-20 h-20' yellow />
            </div>
        )
    }
    if (!employeeData) {
        return null
    }

    const { ids, map } = employeeData

    const chartData = ids.map((id) => map[id])
    return (
        <Card className="flex min-h-[22.5rem] flex-col items-stretch gap-3 py-7 px-14">
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                    <div className="text-xl font-bold">
                        {t('STATISTICS_EMPLOYEES_TABLE_TITLE')}
                    </div>
                </div>
                <div>
                    <img className="cursor-pointer" src={points} alt={'more'} />
                </div>
            </div>
            <div className="flex overflow-hidden rounded-lg">
                <div className="flex flex-1 overflow-auto rounded-lg">
                    <table className="min-h-0 flex-1 text-lg">
                        <HeadRow />
                        <tbody>
                            {chartData.map((c, idx) => (
                                <BodyRow key={idx} employee={c} idx={idx} />
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    )
}

export default EmployeesTableCard
